import {Navigate, Route, Routes} from 'react-router-dom';
import React, {useMemo} from 'react';
import {getRoutes} from './app-routes';
import AdminLayout from './layouts/admin/admin';
import PaymentForm from './pages/payments/payment-form';
import {useAuth} from './contexts/auth';

export default function Content() {
  const {user} = useAuth();
  const routes = useMemo(() => getRoutes(user?.Rights), [user]);

  return (
    <AdminLayout>
      <Routes>
        {routes.map(({path, element}) => (
          <Route
            key={path}
            path={path}
            element={element}
          />
        ))}
        <Route path='/payment/create' element={<PaymentForm mode='create'/>}/>
        <Route path='/payment/view/:paymentId' element={<PaymentForm mode='view'/>}/>
        <Route path='/payment/template/:paymentId' element={<PaymentForm mode='template'/>}/>
        <Route
          path='*'
          element={<Navigate to='/payments'/>}
        />
      </Routes>
    </AdminLayout>
  );
}
